import { createFileRoute } from '@tanstack/react-router'
import IncorporadoraDetailPage from '@/pages/incorporadoras/incorporadora-detail'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

// Rota index para /dashboard/$dashboardId/incorporadoras/$incorporadoraId
// Renderizada quando acessar diretamente /dashboard/$dashboardId/incorporadoras/$incorporadoraId
// Sem rota filha ativa
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/incorporadoras/$incorporadoraId/',
)({
  component: function IncorporadoraDetailRoute() {
    const { dashboardId, incorporadoraId } = Route.useParams()
    return (
      <RequireModule module={MODULES.INCORPORADORA} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.VIEW_IMOB_DATA}>
          <IncorporadoraDetailPage
            incorporadoraId={incorporadoraId}
            dashboardId={dashboardId}
          />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
